import React from "react";
import AuthForm from "../../components/auth/AuthForm";
import styles from "./connect.module.scss";

const Connect = () => {
  return (
    <div className={styles.connectContainer}>
      <h1>Une appli pour vous aider a gerer votre congel !</h1>
      <p className={styles.connectText}>Creez un compte et connectez vous !</p>
      <AuthForm />
    </div>
  );
};

export default Connect;
